
export default function Legal() {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Mentions légales</h1>
          <div className="h-1 w-20 bg-[#9EFD38]"></div>
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Éditeur du site</h2>
            <p className="text-gray-700 mb-2">Le présent site est édité par :</p>
            <p className="text-gray-700 font-semibold">VirtualEat</p>
            <p className="text-gray-700">Responsable de publication : Gabriel Marandyuk</p>
            <p className="text-gray-700">Email : gabrielmarandyukpro@gmail.com</p>
            <p className="text-gray-700">Téléphone : +32 493 81 35 52</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Siège social</h2>
            <p className="text-gray-700">Adresse communiquée sur demande</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Propriété intellectuelle</h2>
            <p className="text-gray-700 mb-4">
              L'ensemble des éléments présents sur ce site (textes, images, graphismes, logo, vidéos, etc.) sont protégés par le droit d'auteur.
            </p>
            <p className="text-gray-700">
              Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable est interdite.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Responsabilité</h2>
            <p className="text-gray-700 mb-4">
              VirtualEat met tout en œuvre pour assurer l'exactitude des informations diffusées.
            </p>
            <p className="text-gray-700 mb-2">Cependant, l'éditeur ne saurait être tenu responsable :</p>
            <ul className="list-disc list-inside text-gray-700 ml-4 space-y-1">
              <li>d'éventuelles erreurs ou omissions,</li>
              <li>d'un mauvais usage des informations présentes,</li>
              <li>ou de problèmes techniques liés à l'utilisation du site.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Protection des données personnelles (RGPD)</h2>
            <p className="text-gray-700 mb-4">
              Les informations collectées via les formulaires (nom, email, téléphone, nom du restaurant) sont nécessaires pour vous recontacter.
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="text-gray-700 mb-2"><strong>Responsable du traitement :</strong> VirtualEat</p>
              <p className="text-gray-700 mb-2"><strong>Finalité :</strong> prise de contact commerciale</p>
              <p className="text-gray-700 mb-2"><strong>Conservation :</strong> max 3 ans</p>
              <p className="text-gray-700">
                <strong>Vos droits :</strong> accès, rectification, suppression de vos données → contactez : gabrielmarandyukpro@gmail.com
              </p>
            </div>
            <p className="text-gray-700">
              Aucune donnée n'est cédée à des tiers sans votre consentement.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookies</h2>
            <p className="text-gray-700 mb-2">
              Le site peut utiliser des cookies pour améliorer l'expérience utilisateur et analyser la fréquentation.
            </p>
            <p className="text-gray-700">
              Vous pouvez paramétrer vos préférences dans votre navigateur.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Droit applicable</h2>
            <p className="text-gray-700">
              Les présentes mentions légales sont régies par le droit belge.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/"
            className="inline-flex items-center text-[#9EFD38] hover:text-[#8AE832] font-semibold transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
}
